import EnumDataSource from "../utils/enum-data-source.util";

const sex = {
  M: "Male",
  F: "Female"
};

// BAS = Birth assigned Sex
export const BAS = new EnumDataSource(sex);

const gender = {
  M: "Man",
  W: "Woman",
  NB: "Non Binary/Other",
  NS: "Not Specified"
};

// Gender options
export const GENDER = new EnumDataSource(gender);

const maritalStatuses = {
  "1": "Single",
  "2": "Married",
  "3": "Divorced",
  "4": "Domestic Partner",
  "5": "Legally Separated",
  "6": "Widowed",
  "99": "Other"
};

export const MARITAL_STATUSES = new EnumDataSource(maritalStatuses);

const employmentStatus = {
  "1": "Full Time",
  "2": "Part Time",
  "3": "Self Employed",
  "4": "Not Employed",
  "5": "Retired",
  "6": "Active Military",
  "7": "Disabled",
  "8": "Student"
};

export const EMPLOYMENT_STATUSES = new EnumDataSource(employmentStatus);

export const CONTACT_RELATIONSHIP_SELF = "0";
export const CONTACT_RELATIONSHIP_OTHER = "99";

export const contactRelationship = {
  [CONTACT_RELATIONSHIP_SELF]: "Self",
  "1": "Spouse",
  "2": "Sibling",
  "3": "Parent",
  "4": "Child",
  "5": "Partner",
  "6": "Caregiver",
  "7": "Friend",
  "8": "Grandchild",
  "9": "Guardian",
  "10": "Relative",
  [CONTACT_RELATIONSHIP_OTHER]: "Other"
};

export const CONTACT_RELATIONSHIP = new EnumDataSource(contactRelationship, {
  [CONTACT_RELATIONSHIP_SELF]: 1,
  "6": 2, // Caregiver
  "4": 3, // Child
  "7": 4, // Friend
  "8": 5, // Grandchild
  "9": 6, // Guardian
  "10": 7, // Relative
  "5": 8, // Partner
  "3": 9, // Parent
  "2": 10, // Sibling
  "1": 11, // Spouse
  [CONTACT_RELATIONSHIP_OTHER]: 12
});

const referralSource = {
  "1": "Current Patient",
  "2": "Physician",
  "3": "Walk In",
  "4": "Practice Website",
  "5": "Google Search",
  "6": "Newsletter",
  "7": "Direct Mail",
  "8": "Radio",
  "99": "Other"
};

export const REFERRAL_SOURCE = new EnumDataSource(referralSource);

export const PRIVATE_PAY_PAYMENT_SOURCE = 1;
export const INSURANCE_PAYMENT_SOURCE = 2;
export const MANAGED_CARE_PAYMENT_SOURCE = 3;
const paymentSourceType = {
  [PRIVATE_PAY_PAYMENT_SOURCE]: "Private Pay",
  [INSURANCE_PAYMENT_SOURCE]: "Insurance",
  [MANAGED_CARE_PAYMENT_SOURCE]: "Managed Care"
};

export const PAYMENT_SOURCE_TYPE = new EnumDataSource(paymentSourceType);

export const QUICK_FILTER_DEFAULT_TYPE = "1";
export const QUICK_FILTER_READY_FOR_DELIVERY = "2";
export const QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE = "3";
export const QUICK_FILTER_NO_SHOW_OR_CANCELED_APPOINTMENT = "5";
export const QUICK_FILTER_WAITLIST = "6";
export const QUICK_FILTER_INACTIVE = "7";
export const QUICK_FILTER_OUTSTANDING_BALANCE_TYPE = "8";
export const QUICK_FILTER_NEEDS_TO_BE_RESCHEDULED = "9";

const patientQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "Active Patients",
  [QUICK_FILTER_READY_FOR_DELIVERY]: "Patients Ready for Delivery",
  // Note: The 'Patients with Outstanding Balance' filter is currently hidden, but may be needed in the future.
  // [QUICK_FILTER_OUTSTANDING_BALANCE_TYPE]: "Patients with Outstanding Balance",
  [QUICK_FILTER_UNCONFIRMED_APPOINTMENTS_TYPE]:
    "Unconfirmed Appointments next 10 Days",
  [QUICK_FILTER_NO_SHOW_OR_CANCELED_APPOINTMENT]:
    "No-Show/Canceled Appointments",
  [QUICK_FILTER_WAITLIST]: "Waitlist",
  [QUICK_FILTER_INACTIVE]: "Deactivated Patients",
  [QUICK_FILTER_NEEDS_TO_BE_RESCHEDULED]: "Needs to be Rescheduled"
};

export const QUICK_FILTER_TYPES = new EnumDataSource(patientQuickFiltersType);

export const PHONE_TYPE_MOBILE = 1;
export const PHONE_TYPE_LANDLINE = 2;

const phoneTypes = {
  [PHONE_TYPE_MOBILE]: "Mobile",
  [PHONE_TYPE_LANDLINE]: "Landline"
};

export const PHONE_TYPES = new EnumDataSource(phoneTypes);

export const COMMUNICATION_METHOD_TEXT_SMS = 1;
export const COMMUNICATION_METHOD_EMAIL = 2;
export const COMMUNICATION_METHOD_VOICE_CALL = 3;
export const COMMUNICATION_METHOD_VOICE_DIRECT_MAIL = 4;
export const COMMUNICATION_METHOD_DO_NOT_CONTACT = 5;
export const COMMUNICATION_METHOD_FAX = 6;

export const BULK_ACTION_TARGET_TOUCHPOINTS_SMS = 3;

const communicationMethods = {
  [COMMUNICATION_METHOD_TEXT_SMS]: "Text/SMS",
  [COMMUNICATION_METHOD_EMAIL]: "Email",
  [COMMUNICATION_METHOD_VOICE_CALL]: "Voice Call",
  [COMMUNICATION_METHOD_VOICE_DIRECT_MAIL]: "Direct Mail",
  [COMMUNICATION_METHOD_DO_NOT_CONTACT]: "Do Not Contact"
} as const;

export const communicationMethodsWithFax = {
  ...communicationMethods,
  [COMMUNICATION_METHOD_FAX]: "Fax"
} as const;

export const COMMUNICATION_METHOD_TYPES = new EnumDataSource(
  communicationMethods
);

export const COMMUNICATION_METHOD_TYPES_WITH_FAX = new EnumDataSource(
  communicationMethodsWithFax
);

export const COMMUNICATION_METHOD_BOTH_TEXT_AND_EMAIL = 5;
export const communicationMethodsGeneratedBy = {
  [COMMUNICATION_METHOD_TEXT_SMS]: "Text/SMS (Automated)",
  [COMMUNICATION_METHOD_EMAIL]: "Email (Automated)",
  [COMMUNICATION_METHOD_BOTH_TEXT_AND_EMAIL]:
    "Both Email and Text/SMS (Automated)",
  [COMMUNICATION_METHOD_VOICE_CALL]: "Voice Call (Manual)",
  [COMMUNICATION_METHOD_VOICE_DIRECT_MAIL]: "Direct Mail (Manual)",
  [COMMUNICATION_METHOD_FAX]: "Fax (Manual)"
} as const;

export const COMMUNICATION_METHOD_TYPES_GENERATED_BY = new EnumDataSource(
  communicationMethodsGeneratedBy,
  //options order
  {
    [COMMUNICATION_METHOD_TEXT_SMS]: 1,
    [COMMUNICATION_METHOD_EMAIL]: 2,
    [COMMUNICATION_METHOD_BOTH_TEXT_AND_EMAIL]: 3,
    [COMMUNICATION_METHOD_VOICE_CALL]: 4,
    [COMMUNICATION_METHOD_VOICE_DIRECT_MAIL]: 5,
    [COMMUNICATION_METHOD_FAX]: 6
  }
);

export const CRM_SEGMENT_PROSPECT = 1;
export const CRM_SEGMENT_NOT_CONVERTED = 2;
export const CRM_SEGMENT_HA_USER = 3;
export const CRM_SEGMENT_END_OF_WARRANTY = 4;

const crmSegments = {
  [CRM_SEGMENT_PROSPECT]: "Prospect",
  [CRM_SEGMENT_NOT_CONVERTED]: "Not Converted",
  [CRM_SEGMENT_HA_USER]: "HA User",
  [CRM_SEGMENT_END_OF_WARRANTY]: "End Of Warranty"
};

export const CRM_SEGMENTS = new EnumDataSource(crmSegments);

export const NOAH_ES = 1;
export const NOAH_MOBILE = 2;
export const PATIENTS_LIST_KEY_DEFAULT = "patientsList";
